export enum QuotePartNoteType {
  BUYER = 'buyer',
  DEFAULT = 'default',
  INTERNAL = 'internal',
  LEAD_TIME = 'lead_time',
  PICKER = 'picker',
  SUPSHIP = 'supship',
  UNDISCARDABLE_ITEM = 'undiscardable_item',
}
